interface IDXDisclaimerProps {
  variant?: "full" | "short" | "inline";
  className?: string;
}

const IDXDisclaimer = ({ variant = "short", className = "" }: IDXDisclaimerProps) => {
  const year = new Date().getFullYear();
  const fullDisclaimer = `© ${year} Bright MLS. All rights reserved. Information Deemed Reliable, but Not Guaranteed. Listing information is from various brokers who participate in IDX and not all listings may be visible on the site. The property information being provided is for consumers personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Data updated frequently from IDX Broker`;

  const shortDisclaimer = `© ${year} Bright MLS. Information Deemed Reliable, but Not Guaranteed.`;

  const inlineDisclaimer = `© ${year} Bright MLS. IDX Provided by IDX Broker`;

  if (variant === "full") {
    return (
      <div className={`text-xs text-muted-foreground space-y-3 ${className}`}>
        <p>{fullDisclaimer}</p>
        <p className="font-medium">IDX Provided by IDX Broker</p>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <span className={`text-xs text-muted-foreground ${className}`}>
        {inlineDisclaimer}
      </span>
    );
  }

  // Default: short
  return (
    <p className={`text-xs text-muted-foreground ${className}`}>
      {shortDisclaimer}
    </p>
  );
};

export default IDXDisclaimer;
